export default {
      id: "Vectorstatistics-usage",
      viewBox: "0 0 41 45",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#Vectorstatistics",
      toString: function () {
        return this.url;
      }
    }